resourcePaths = '{"rootPath":"","assetsPath":""}';/**
 * Created by trevor on 2015-03-11.
 */

function _RSS() {
    this.node = null;
    this.id = null;
    this.declaredClass = null;

    this._PAGE_LIMIT = 10;

    this.getRSS = function(url, callback) {
        if (mogo.registry.mogoUI.blogRSSLoading == undefined)
            mogo.registry.mogoUI.blogRSSLoading = false;

        if (mogo.registry.mogoUI.blogRSSCallbacks == undefined)
            mogo.registry.mogoUI.blogRSSCallbacks = new Array();

        if (Modernizr.localstorage) {
            if (localStorage.getItem("blogRSS") != null) {
                mogo.registry.mogoUI.blogRSS = $.parseXML(localStorage.getItem("blogRSS"));
                var lastBuildDate = new Date($(mogo.registry.mogoUI.blogRSS).find("lastBuildDate").text());
                var currentDate = new Date();
                if ((currentDate.getTime() - lastBuildDate.getTime()) < 43200000) { // Less than 12 hours old
                    callback(mogo.registry.mogoUI.blogRSS);
                    return;
                } else {
                    localStorage.removeItem("blogRSS");
                    mogo.registry.mogoUI.blogRSS = undefined;
                }
            }
        }

        if (mogo.registry.mogoUI.blogRSS) {
            if (callback != null)
                callback(mogo.registry.mogoUI.blogRSS);
        } else if (mogo.registry.mogoUI.blogRSSLoading) {
            if (callback != null)
                this._registerCallback(callback);
        } else {
            mogo.registry.mogoUI.blogRSSLoading = true;
            if (callback != null)
                this._registerCallback(callback);
            this._getFeed(url, 1);
        }
    };

    // returns post
    this.lookupRSSbyURI = function(uri) {
        var item = $(mogo.registry.mogoUI.blogRSS).find("item");
        var target = this;
        var result;

        item.each(function(){
            var link = target.parseURLtoURI( $(this).find("link").text() );

            if (uri == link) {
                result = $(this);
                return false;
            }
        });
        return result;
    };

    // returns array of posts
    this.lookupRSSbyCategories = function(categories, count) {
        var post = $(mogo.registry.mogoUI.blogRSS).find("item");
        var node = this;
        var URIs = [];
        var posts = [];

        post.each(function(){
            if (posts.length < count) {
                var itemPost = $(this);
                var itemCategory = $(this).find('category');

                $(itemCategory).each(function(){
                    var itemURL = itemPost.find("link").text();
                    var itemURI = node.parseURLtoURI(itemURL);
                    var cat = $(this).text();

                    // match categories, exclude posts of same URI
                    if (categories.contains(cat) && itemURI !== window.location.pathname && URIs.contains(itemURI) === false) {
                        URIs.push(itemURI);
                        posts.push(itemPost.context);
                    }
                });
            } else {
                return false;
            }
        });

        return posts;
    };

    this.getPostImage = function(post) {
        var imgSrc = $(post).find('media\\:content, content').attr('url');
        return imgSrc ? imgSrc : "https://mogofiles.s3.amazonaws.com/images/placeholder-thumb.gif";
    };

    // returns array of post's categories
    this.getPostCategories = function(post) {
        var category = $(post).find('category');
        var categories = [];

        $(category).each(function(){
            var cat = $(this).text().toLowerCase();
            cat == 'featured'? categories.unshift(cat) : categories.push(cat);
        });

        return categories[0];
    };

    // returns uri of url
    this.parseURLtoURI = function(url) {
        var a = document.createElement('a');
        a.href = url;
        return a.pathname;
    };

    this._getFeed = function(url, index) {
        var page = "";
        if (index > 1) {
            page = "/" + index;
        }

        $.ajax({
            url: url + page,
            dataType: 'xml',
            type: 'GET',
            context: document.body,
            success: $.proxy(this._onPartialSuccess, this, index, url),
            error: function(error) {
                console.log("error ", error);
            }
        });
    };

    this._onPartialSuccess = function(index, url, result) {
        if (mogo.registry.mogoUI.blogRSS === undefined) {
            mogo.registry.mogoUI.blogRSS = result;
        } else {
            // Last Item current
            var lastItem = $(mogo.registry.mogoUI.blogRSS).find("item");
            lastItem = lastItem[lastItem.length - 1];
            var lastItemGuid = $(lastItem).find("guid").text();

            // Last Item RSS
            var resultList = $(result).find("item");
            var resultLastItem = resultList[resultList.length - 1];
            var resultLastItemGuid  = $(resultLastItem).find("guid").text();

            if (lastItemGuid == resultLastItemGuid) {
                this._onSuccess();
                return;
            } else {
                // Add result to current
                for (var i = 0; i < resultList.length; i++) {
                    var item = resultList[i];
                    $(mogo.registry.mogoUI.blogRSS).find("channel").append(item);
                }

                if (index >= this._PAGE_LIMIT) {
                    this._onSuccess();
                    return;
                }
            }
        }
        index++;
        this._getFeed(url, index);
    };

    this._onSuccess = function() {
        // Set in local storage
        if (Modernizr.localstorage) {
            try {
                var serializer = new XMLSerializer();
                localStorage.setItem("blogRSS", serializer.serializeToString(mogo.registry.mogoUI.blogRSS));
            } catch (e) {}
        }

        // Execute registered callbacks
        for (var i = mogo.registry.mogoUI.blogRSSCallbacks.length - 1; i >= 0; i--) {
            mogo.registry.mogoUI.blogRSSCallbacks[i](mogo.registry.mogoUI.blogRSS);
        }
    };

    this._registerCallback = function(callback) {
        mogo.registry.mogoUI.blogRSSCallbacks.push(callback);
    }
}